import { useState, useRef, useEffect } from "react";
import { HiChevronDown } from "react-icons/hi";

const CustomDropdown = ({ label, options, selected, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
        className='customDropdown'
        onClick={() => setIsOpen(!isOpen)}
      >
        <div>{selected}</div>
        <div className='arrow'><HiChevronDown /></div>

        {isOpen && (
          <ul className='dropdownList'>
            {options.map((option) => (
              <li
                key={option}
                className={option === selected ? 'selectedOption' : ""}
                onClick={() => {
                  onChange(option);
                  setIsOpen(false);
                }}
              >
                {option}
              </li>
            ))}
          </ul>
        )}
      </div>
  );
};

export default CustomDropdown;
